import storeModuleFactory from 'util/storeModule/storeModuleFactory';
import endpoints from 'config/endpoints';
import {TIMEOUT_STORE, TIMESTAMP_MULTIPLY} from 'util/constants';

module.exports = {
    createFetchParams: (startDate, filters) => ({
        operable: filters.operable,
        date:     Math.floor(startDate / TIMESTAMP_MULTIPLY)
    }),
    ...storeModuleFactory({
        name:               'CMDBPatchCake',
        endpoint:           endpoints.cmdb.patchCake,
        timeout:            TIMEOUT_STORE.TIMEOUT_STORE_BIG,
        transformResultsFn: response => ({
            total:   response.with_patch + response.without_patch,
            results: [
                {
                    name: 'withPatch',
                    y:    response.with_patch
                },
                {
                    name: 'withoutPatch',
                    y:    response.without_patch
                }
            ]
        })
    })
};



// WEBPACK FOOTER //
// ./src/modules/store/CMDBPatchCake.js